import React, { useEffect, useState } from 'react';
import Header from '../Element/Header'
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Avatar from '@material-ui/core/Avatar';
import axios from 'axios'
import convertToRupiah from '../Helper/Currency'
import onSubmit from './OnSubmit'
import { useLocation, useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    minWidth: 300,
    marginTop: theme.spacing(4)
  }
}))

export default function PaymentPackage() {
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()
  const [paket, setPaket] = useState([])


  useEffect(() => {
    if (location.state == undefined) {
      return history.push({
        pathname: '/register'
      })
    }
    async function asyncFunc() {
      try {
        const paket = await axios.get(`${process.env.REACT_APP_API}/participant/payment/package`)
        return setPaket(paket.data)
      } catch (error) {
        console.log("error", error);
      }
    }

    asyncFunc()
  }, [])
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div style={{
        marginTop: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <Header />
        <Typography component="h1" variant="h6" gutterBottom>
          Pilih Paket Pembayaran
        </Typography>
        <div style={{ marginTop: 30 }}>
          {paket.map((value) => {
            let obj = {
              desc_1: value.desc.split("\n", 1)[0],
              desc_2: value.desc.split("\n").slice(1).join(' '),
            }
            let desc_slice = Object.assign(value, obj)
            console.log(desc_slice)
            return (
              <Card className={classes.root} key={value.id}>
                <CardActionArea onClick={() => {
                  let User = location.state
                  onSubmit(User.name, User.email, User.no_wa, User.zoom_user, value.id, User.getParticipant, User.getPayment, history)
                }}>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                      {value.name} {convertToRupiah(value.price)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                      {desc_slice.desc_1}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                      {desc_slice.desc_2}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            )
          })}
        </div>
      </div>
    </Container>
  );
}